import type { Message, UploadFile } from '@entities/post/model/types'
import { MessageType } from '@entities/post/model/types'
import { Flex, Image, Space, Typography } from 'antd'
import type { Post } from '@entities/post'
import { stripHtml } from '@shared/lib/stripHtml/stripHtml'
import Img from '../../assets/rejectImg.png'
const { Text } = Typography

export const mappingText = (text: string, color?: string) => (
    <Text style={{ color: color }}>{text?.length > 20 ? `${stripHtml(text).slice(0, 20)}...` : stripHtml(text)}</Text>
)

const mappingAlbum = (file: UploadFile) => {
    const {
        response: { file_name, file_type, file_url }
    } = file
    switch (file_type) {
        case MessageType.PHOTO:
            return <Image height={50} width={60} src={file_url} />
        case MessageType.VIDEO:
            return (
                <>
                    <video style={{ width: 150 }} controls>
                        <source src={file_url} />
                        Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                    </video>
                </>
            )
        case MessageType.AUDIO || MessageType.VOICE:
            return (
                <>
                    <span style={{ margin: '10px 0 5px 0', display: 'inline-block', fontSize: '12px' }}>
                        {file_name}
                    </span>
                    <audio style={{ width: '100%' }} controls>
                        <source src={file_url} />
                        Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                    </audio>
                </>
            )
        case MessageType.DOCUMENT:
            return <Text style={{ fontSize: '12px' }}> Документ: {file_name} </Text>
        default:
            return <Image height={50} width={60} src={Img} />
    }
}
const mappingPreview = (item: Message) => {
    const { messageType, file, question } = item

    switch (messageType) {
        case MessageType.PHOTO:
            return (
                <Flex gap={'small'} vertical>
                    {file.map((file) => (
                        <Image key={file.response.id} height={50} width={60} src={file.response.file_url} />
                    ))}
                </Flex>
            )
        case MessageType.VIDEO:
            return (
                <Flex gap={'small'} vertical>
                    {file.map((file) => (
                        <video style={{ height: 50 }} controls>
                            <source src={file.response.file_url} />
                            Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                        </video>
                    ))}
                </Flex>
            )
        case MessageType.AUDIO || MessageType.VOICE:
            return (
                <Flex gap={'small'} vertical>
                    {file.map((file) => (
                        <>
                            <span style={{ margin: '10px 0 5px 0', display: 'inline-block', fontSize: '12px' }}>
                                {mappingText(file?.response.file_name)}
                            </span>
                            <audio style={{ width: '100%', height: 100 }}>
                                <source src={file?.response?.file_url} />
                                Your browser does not support the video tag. Ваш браузер не поддерживает аудио-плеер.
                            </audio>
                        </>
                    ))}
                </Flex>
            )
        case MessageType.DOCUMENT:
            return (
                <Flex gap={'small'} vertical>
                    {file.map((file) => (
                        <div key={file.response.id}>
                            <Text style={{ fontSize: '12px' }} key={file.response.id}>
                                Документ
                            </Text>
                        </div>
                    ))}
                </Flex>
            )
        case MessageType.QUIZ:
            return (
                <Flex gap={'small'} vertical>
                    <Text> Опрос </Text>
                    <Text>{question}</Text>
                </Flex>
            )
        case MessageType.ALBUM:
            return (
                <>
                    <Flex gap={'small'} vertical>
                        {mappingAlbum(file[0])}
                    </Flex>
                </>
            )
        default:
            return <Image height={50} width={60} src={Img} />
    }
}

export const PreviewPostText = ({ post }: { post: Post }) => {
    if (post?.advertisingInfo?.budget) {
        return <Text>{post?.advertisingInfo?.budget > 0 ? 'Рекламный' : 'Коллаборация'}</Text>
    }
    return <Text>{post.postType?.name || 'Базовый'}</Text>
}

const SmallPreviewPost = ({ post }: { post: Post }) => {
    const stopProp = (e: React.MouseEvent) => {
        e.stopPropagation()
    }
    return (
        <Space onClick={stopProp}>
            {post?.messages?.map((item) => {
                return mappingPreview(item)
            })}
        </Space>
    )
}

export default SmallPreviewPost
